var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecruitment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.078,
    height: 20,
    viewBox: "0 0 20.078 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Recruitment",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M110.225,9.787v3.185h3.185Zm-4.052,14.22a5,5,0,1,0-7.347,0,2.928,2.928,0,0,1,1.707-2.161,2.549,2.549,0,1,1,3.934,0A2.928,2.928,0,0,1,106.174,24.007Z",
    transform: "translate(-93.676 -8.442)",
    fill: "#7b818e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_430",
    "data-name": "Ellipse 430",
    cx: 1.091,
    cy: 1.091,
    r: 1.091,
    transform: "translate(7.634 10.325)",
    fill: "#7b818e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M158.133,342.472l-.1.624a4.99,4.99,0,0,0,5.253,0l-.1-.624A1.757,1.757,0,0,0,161.44,341h-1.569A1.757,1.757,0,0,0,158.133,342.472Z",
    transform: "translate(-151.832 -326.667)",
    fill: "#7b818e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M133.176,5.706a.588.588,0,0,1-.588-.588V1h-9.216A1.374,1.374,0,0,0,122,2.373V7.507a6.165,6.165,0,0,1,7.217-.625h5.136a.588.588,0,1,1,0,1.176h-3.714a6.206,6.206,0,0,1,.831,1.176h2.884a.588.588,0,1,1,0,1.176h-2.395a6.134,6.134,0,0,1,.229,1.176h2.165a.588.588,0,1,1,0,1.176h-2.165a6.134,6.134,0,0,1-.229,1.176h2.395a.588.588,0,1,1,0,1.176h-2.884a6.174,6.174,0,0,1-7.8,2.761L122,19.543v.084A1.374,1.374,0,0,0,123.373,21h12.549a1.374,1.374,0,0,0,1.373-1.373V5.706Zm-2.353,0h-5.882a.588.588,0,0,1,0-1.176h5.882a.588.588,0,1,1,0,1.176Zm3.529,11.765h-3.137a.588.588,0,1,1,0-1.176h3.137a.588.588,0,1,1,0,1.176Z",
    transform: "translate(-117.216 0)",
    fill: "#7b818e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M3.706,374.081.345,377.442a1.176,1.176,0,0,0,1.664,1.664l3.361-3.361a6.226,6.226,0,0,1-1.664-1.664Z",
    transform: "translate(0 -358.45)",
    fill: "#7b818e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitment);
export default __webpack_public_path__ + "static/media/Recruitment.ebda68b2eaef795818824720cd7e842b.svg";
export { ForwardRef as ReactComponent };